import { useEffect } from 'react';
import styles from './HangeshwarPublicSchool.module.css';

export default function HangeshwarPublicSchool() {

    useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
    

    return (       
        <section className={styles.Page} id='hangeshwarPublicSchool'>
            <h2 className={styles.PageName}>Hangeshwar Public School</h2>
            
            <div className={styles.aboutUsInfo}>
                <div className={styles.aboutUsinformation}>
                        <div className={styles.introSection}>
                            <img src='/icons/hangeshwarPublicSchoolLogo.webp' alt='school logo' />
                            <div className={styles.moto}>
                                <h3 className={styles.slogan}>Knowledge is Power</h3>
                            </div>
                    
                            <p>
                                Saiseva Bahuuddeshiya Seva Pratishthan's,<br/>
                                Hangeshwar Public School<br/>
                                Chimbhale, Tal. Shrigonda, Dist. Ahilya Nagar, Maharashtra.
                            </p>
                        </div>

                        <div className={styles.historySection}>
                        <p>
                            Established in 2010 at Chimbhale, Tal. Shrigonda, Dist. Ahilyanagar, Maharashtra, 
                            Hangeshwar Public School is affiliated with the Maharashtra Board of Secondary and Higher Secondary Education, Pune.
                            The school offers English-medium education for students from <strong>Nursery to Senior KG (pre-primary)</strong> and <strong>1st to 7th grade (primary)</strong>, providing quality learning opportunities to children from rural areas of Shrigonda and Shirur talukas.  
                            With a focus on academic excellence and overall development, the school aims to nurture young minds in a supportive and enriching environment.
                        </p>
                        <p>
                            The school provides <strong>RTE facilities for EWS and category</strong> students. It operates in its own building, 
                            surrounded by a natural environment, and features digital classrooms, experienced staff, and transport services.</p>
                        </div>
                       
                    </div>
                    </div>
            
        </section>        
    )
}